<script setup>
import { ref, onMounted } from 'vue'
import redeMarketingApi from '@/services/api/redeMarketingRepository'
import { useStore } from '@/store'

const store = useStore()
const loading = ref(true)
const error = ref(null)
const user = ref(null)

onMounted(async () => {
  try {
    if (!store.redeMarketingJwt && store.token) {
      const loginResp = await redeMarketingApi.Login(store.token)
      store.setRedeMarketingJwt(loginResp.data.token)
      user.value = loginResp.data.user
    } else {
      const meResp = await redeMarketingApi.Me()
      user.value = meResp.data
    }
  } catch (e) {
    error.value = e.response?.data?.message || e.message
    store.setRedeMarketingJwt(null)
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h3 class="mb-0">Rede de Marketing</h3>
        <small class="text-muted">MMN trainer-to-trainer integrado ao Diário de Treino</small>
      </div>
      <div>
        <span v-if="loading" class="badge bg-secondary">
          <i class="material-icons align-middle" style="font-size: 14px;">sync</i> Verificando...
        </span>
        <span v-else-if="error" class="badge bg-danger">
          <i class="material-icons align-middle" style="font-size: 14px;">error</i> Desconectado
        </span>
        <span v-else class="badge bg-success">
          <i class="material-icons align-middle" style="font-size: 14px;">check_circle</i>
          {{ user?.email }}
        </span>
      </div>
    </div>

    <div v-if="error" class="alert alert-warning d-flex align-items-center">
      <i class="material-icons me-2">warning</i>
      <div>
        <strong>Não foi possível conectar ao backend da rede.</strong><br>
        <small>{{ error }}</small>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-md-6 col-lg-4">
        <router-link to="/rede-marketing/dashboard" class="nav-card nav-card-destaque">
          <i class="material-icons nav-icon">dashboard</i>
          <div class="flex-1">
            <h5>Dashboard</h5>
            <p>Métricas, top patrocinadores e crescimento</p>
          </div>
        </router-link>
      </div>

      <div class="col-md-6 col-lg-4">
        <router-link to="/rede-marketing/membros" class="nav-card">
          <i class="material-icons nav-icon text-primary">groups</i>
          <div class="flex-1">
            <h5>Treinadores na Rede</h5>
            <p>Lista, cadastro e ativação</p>
          </div>
        </router-link>
      </div>

      <div class="col-md-6 col-lg-4">
        <router-link to="/rede-marketing/genealogia" class="nav-card">
          <i class="material-icons nav-icon text-success">account_tree</i>
          <div class="flex-1">
            <h5>Genealogia (Árvore)</h5>
            <p>Visualização em árvore visual</p>
          </div>
        </router-link>
      </div>

      <div class="col-md-6 col-lg-4">
        <router-link to="/rede-marketing/rede-linear" class="nav-card">
          <i class="material-icons nav-icon text-info">list_alt</i>
          <div class="flex-1">
            <h5>Rede Linear</h5>
            <p>Lista hierárquica expansível</p>
          </div>
        </router-link>
      </div>

      <div class="col-md-6 col-lg-4">
        <router-link to="/rede-marketing/ranks" class="nav-card">
          <i class="material-icons nav-icon text-warning">military_tech</i>
          <div class="flex-1">
            <h5>Ranks</h5>
            <p>Graduações e recálculo mensal</p>
          </div>
        </router-link>
      </div>

      <div class="col-md-6 col-lg-4">
        <router-link to="/rede-marketing/configuracao" class="nav-card">
          <i class="material-icons nav-icon text-secondary">tune</i>
          <div class="flex-1">
            <h5>Configuração</h5>
            <p>Feature flags de bônus e parâmetros</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 18px 20px;
  text-decoration: none;
  color: inherit;
  transition: all 0.15s;
  height: 100%;
}

.nav-card:hover {
  border-color: #0d6efd;
  box-shadow: 0 6px 20px rgba(13, 110, 253, 0.1);
  transform: translateY(-2px);
}

.nav-icon {
  font-size: 2.2rem;
  flex-shrink: 0;
}

.nav-card h5 {
  margin: 0;
  font-size: 1rem;
  color: #212529;
}

.nav-card p {
  margin: 2px 0 0 0;
  font-size: 0.82rem;
  color: #6c757d;
}

.nav-card-destaque {
  background: linear-gradient(135deg, #0d6efd 0%, #6610f2 100%);
  color: #fff;
  border-color: transparent;
}
.nav-card-destaque:hover {
  box-shadow: 0 10px 30px rgba(13, 110, 253, 0.3);
}
.nav-card-destaque .nav-icon,
.nav-card-destaque h5 {
  color: #fff;
}
.nav-card-destaque p {
  color: rgba(255, 255, 255, 0.85);
}

.flex-1 { flex: 1; }
</style>
